// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"ButtonIcon_buttonIcon__K7_Z6","disabled":"ButtonIcon_disabled__qo4IX","fill":"ButtonIcon_fill__IAiqo","outline":"ButtonIcon_outline__2YQZ6"};